import {PaymentsAPI} from "../api/PaymentsAPI";
import {BaseService} from "./BaseService";
import {Payment} from "../models/Payment";
import {
	actionPaymentFetchAllCompleted,
	actionPaymentFetchCompleted,
	actionPaymentSaveCompleted,
	actionPaymentDeleteCompleted,
	actionDeletePaymentsCompleted, actionPaymentFetchByCustomerCompleted
} from "../store/payments/actions";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {Customer} from "../models/Customer";
import {actionInvoiceFetchByCustomerCompleted} from "../store/invoices";
import {actionToastrInfo} from "../store/global";

export default class PaymentsService extends BaseService {

	static getAll() {
		let paymentsAPI: PaymentsAPI = new PaymentsAPI()
		paymentsAPI.getAll().then(PaymentsService.processResponse)
		.then((data) => actionPaymentFetchAllCompleted(PaymentsService.responseToPayments(data)))
		.catch(error => ErrorService.handleError(error))
	}

	static save(payment: Payment) {
		let paymentsAPI: PaymentsAPI = new PaymentsAPI()
		if (payment.id) {
			paymentsAPI.put(PaymentsService.paymentToRequest(payment)).then(PaymentsService.processResponse)
			.then((data) => {
				actionPaymentSaveCompleted(PaymentsService.responseToPayment(data))
				actionSetTabStateItem(PaymentsService.responseToPayment(data))
				actionSetTabItem(PaymentsService.responseToPayment(data))
				actionToastrInfo("Info", "Uplata je uspešno snimljena")
			})
			.catch(error => ErrorService.handleError(error))
		} else {
			paymentsAPI.post(PaymentsService.paymentToRequest(payment)).then(PaymentsService.processResponse)
				.then((data) => {
					actionPaymentSaveCompleted(PaymentsService.responseToPayment(data))
					actionSetTabItem(PaymentsService.responseToPayment(data))
					actionSetTabStateItem(PaymentsService.responseToPayment(data))
					actionToastrInfo("Info", "Uplata je uspešno snimljena")
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static getOne (payment: Payment) {
		const paymentsAPI: PaymentsAPI = new PaymentsAPI()
		paymentsAPI.get(payment).then(PaymentsService.processResponse)
		.then((data) => {
			actionPaymentFetchCompleted(PaymentsService.responseToPayment(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static delete(payment: Payment) {
		const paymentsAPI: PaymentsAPI = new PaymentsAPI()
		paymentsAPI.delete(payment).then(
			(data) => {
				actionDeleteTabForItemId(payment.id)
				actionPaymentDeleteCompleted(payment)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deletePayments(payments: Payment[]) {

		const paymentsAPI: PaymentsAPI = new PaymentsAPI()
		let count = 0;
		payments.forEach(payment => {

			paymentsAPI.delete(PaymentsService.paymentToRequest(payment)).then(PaymentsService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(payment.id)
					if(count === payments.length)
						actionDeletePaymentsCompleted(payments)
				}
			).catch(error => ErrorService.handleError(error))
		});
	}


	static responseToPayment (data: any): Payment {
		let payment = new Payment()
		payment.description = data.description
		payment.price = data.price
		payment.paymentDate = data.date
		payment.id = data.id
		payment.uploads = data.uploads
		payment.customerId = data.customerId
		payment.invoiceId = data.invoiceId

		return payment
	}

	static responseToPayments (data: any) {
		for (let item of data) {
			item.paymentDate = item.date
		}
		return data
	}

	static paymentToRequest (payment: Payment): any {
		let data: any = payment
		data.uploads = null
		data.date = payment.paymentDate
		return payment
	}

	static getByCustomer(customer: Customer) {

		let paymentsAPI: PaymentsAPI = new PaymentsAPI()
		paymentsAPI.getByCustomer(customer.id)
			.then(PaymentsService.processResponse)
			.then((data) => actionPaymentFetchByCustomerCompleted(data))
			.catch(error => ErrorService.handleError(error))
	}
}
